import { ButtonProps } from "../../../../../atoms/Button/Button";
import { Icon } from "../../../../../atoms/Icon";
import { sizes } from "../../../../../design-tokens/dimensions";
import { Root } from "./styles";

type NavButtonProps = {
  /**
   * Action to perform when the button is clicked
   */
  onClick: ButtonProps["onClick"];
  /**
   * Determines which icon to display
   */
  iconVariant: "left" | "right";
} & ButtonProps;

export const NavButton = ({ onClick, iconVariant, ...rest }: NavButtonProps) => (
  <Root data-testid={NavButton.name} variant="secondary" onClick={onClick} {...rest}>
    <Icon icon={iconVariant === "left" ? "arrow-left" : "arrow-right"} height={sizes.s16.px} />
  </Root>
);
